import React, { ReactNode, useState } from 'react'

import './Tabs.sass'

interface TabsProps {
  headers: ReactNode[]
  tabs: ReactNode[]
}

const Tabs = ({ headers = [], tabs = [] }: TabsProps) => {
  const [selected, setSelected] = useState(0)
  return (
    <div className="tabs">
      <header className="tabs-header">
        {
          headers.map((header, i) =>
            <div
              key={i}
              className={`header-tab ${i === selected ? 'selected' : ''}`}
              onClick={() => setSelected(i)}
            >
              {header}
            </div>
          )
        }
      </header>
      <div className="tabs-content">
        <div className="content-tab">
          {tabs[selected]}
        </div>
      </div>
    </div>
  )
}

export default Tabs
